import React from 'react'
import UsePlanPaymentHistory from './Hooks/usePlanPaymentHistory'
import { ToastContainer } from 'react-bootstrap'
import Spinner from '../Spinner/spinner'
import moment from 'moment'
import Pagination from '../Pagination/pagination'

const ViewPlanPaymentHistory = () => {
    const {
        setPage,
        spinner,
        count,
        listData,
        page,
        PER_PAGE
    } = UsePlanPaymentHistory()
    return (
        <section>
            <ToastContainer />
            <div className="m-t-3 cus-padd cusheight">
                {spinner ? <Spinner /> : null}

                <p>Total Payment History : {listData.totalCount}</p>
            <table className="table  shadow mt-3">
                <thead className="table-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Payment Mode</th>
                        <th scope="col">Start Date</th>
                        <th scope="col">End Date</th>
                        <th scope="col">Validity</th>
                        <th scope="col">Status</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        !listData?.data?.length ? <div className='position-absolute top-10 end-50 mt-5'><h3>No record found</h3></div>
                            :
                            <>
                                {
                                    listData.data?.map((item, index) => {
                                        return <>
                                            <tr key={index}>
                                                <th style={{ padding: '0.4rem .5rem' }} scope="row">{PER_PAGE * (page - 1) + index + 1}</th>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item.paymentMode === 'STRIPE' ? '$' : '₹'}{item.paidAmount}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item.paymentMode}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{moment(item.startDate).format('DD/MM/YYYY')}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{moment(item.endDate).format('DD/MM/YYYY')}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item.validity}</td>
                                                <td style={{ padding: '0.4rem .5rem' }}>{item.success||'--'}</td>

                                            </tr>
                                        </>
                                    })
                                }
                            </>
                    }
                </tbody>
            </table>
            <div className='w-100 d-flex justify-content-center'>
                {count > 10 &&
                    <Pagination setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />
                }
            </div>
            </div>
        </section>
    )
}

export default ViewPlanPaymentHistory